<template>
    <div class="usage-details" v-on:keyup.enter="searchButtonClicked()">
        <div>
            <div class="rows" style="margin: 3rem auto;">
                <input
                    class=""
                    name="instance"
                    type="text"
                    v-model="search"
                    id="instance"
                    :placeholder="$t('support.dashboard.instancename')"
                />
                <button class="btn btn-success" v-on:click="searchButtonClicked()">
                    {{ $t('support.dashboard.searchButton') }}
                </button>
            </div>
            <h2>{{ $t('support.usageDetails.header') }} {{ instance }}</h2>
            <div class="ct-row">
                <div class="usage-infos">
                    <h3>{{ $t('support.usageDetails.usageLicenseData') }}</h3>
                    <ul class="list-group">
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.persons === 1, 'usage-nonfree': usage.persons > 50 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.persons') }}:</b></span
                            >
                            <span class="content">{{ usage.persons }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.services === 8, 'usage-nonfree': usage.services > 10 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.services') }}:</b></span
                            >
                            <span class="content">{{ usage.services }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.resources === 3, 'usage-nonfree': usage.resources > 5 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.resources') }}:</b></span
                            >
                            <span class="content">{{ usage.resources }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.calendars === 3, 'usage-nonfree': usage.calendars > 5 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.calendars') }}:</b></span
                            >
                            <span class="content">{{ usage.calendars }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.stations === 1, 'usage-nonfree': usage.stations > 1 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.stations') }}:</b></span
                            >
                            <span class="content">{{ usage.stations }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="ct-row">
                <div class="usage-infos">
                    <h3>{{ $t('support.usageDetails.usageDataLast30Days') }}</h3>
                    <ul class="list-group">
                        <li
                            class="list-group-item"
                            :class="{
                                'usage-none': usage.personsActive30Days === 0,
                                'usage-okay': usage.personsActive30Days > 0
                            }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.personsActive30Days') }}:</b></span
                            >
                            <span class="content">{{ usage.personsActive30Days }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.persons30 === 0, 'usage-okay': usage.persons30 > 0 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.persons30') }}:</b></span
                            >
                            <span class="content">{{ usage.persons30 }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.groups30 === 0, 'usage-okay': usage.groups30 > 0 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.groups30') }}:</b></span
                            >
                            <span class="content">{{ usage.groups30 }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.csEntries30 === 0, 'usage-okay': usage.csEntries30 > 0 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.csEntries30') }}:</b></span
                            >
                            <span class="content">{{ usage.csEntries30 }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.crEntries30 === 0, 'usage-okay': usage.crEntries30 > 0 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.crEntries30') }}:</b></span
                            >
                            <span class="content">{{ usage.crEntries30 }}</span>
                        </li>
                        <li
                            class="list-group-item"
                            :class="{ 'usage-none': usage.calEntries30 === 0, 'usage-okay': usage.calEntries30 > 0 }"
                        >
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.calEntries30') }}:</b></span
                            >
                            <span class="content">{{ usage.calEntries30 }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="ct-row">
                <div class="usage-infos">
                    <h3>{{ $t('support.usageDetails.licenseOverUnder') }}</h3>
                    <ul class="list-group">
                        <li class="list-group-item" :class="{ 'usage-okay': usage.currentPrice > usage.bestPrice }">
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.overLicensed') }}:</b></span
                            >
                            <span class="content">{{
                                (usage.currentPrice - usage.bestPrice > 0 ? usage.currentPrice - usage.bestPrice : 0) /
                                    100 +
                                    '€'
                            }}</span>
                        </li>
                        <li class="list-group-item" :class="{ 'usage-none': usage.bestPrice > usage.currentPrice }">
                            <span class="title"
                                ><b>{{ $t('support.usageDetails.underLicensed') }}:</b></span
                            >
                            <span class="content">{{
                                (usage.bestPrice - usage.currentPrice > 0 ? usage.bestPrice - usage.currentPrice : 0) /
                                    100 +
                                    '€'
                            }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            search: ''
        };
    },
    props: ['instance'],
    computed: {
        usage() {
            return this.$store.getters['support/loadedUsage'];
        }
    },
    mounted() {
        if (this.instance) {
            this.search = this.instance;
            this.searchButtonClicked();
        }
    },
    methods: {
        searchButtonClicked() {
            this.instance = this.search;
            this.$router.push({ path: '/support/usage/' + this.search });
            this.$store.dispatch('support/loadUsageByInstance', { instance: this.search });
        }
    }
};
</script>
